(() => {
  const page = document.querySelector('[data-search-page]');
  if (!page) return;

  const initialPagination = page.querySelector('[data-search-pagination]');
  const initialResultCount = page.querySelector('[data-result-count]');
  if (initialPagination?.hasAttribute('data-filtered-search') && initialResultCount) {
    initialResultCount.textContent = initialPagination.dataset.visible || '0';
  }

  page.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-load-more]');
    if (!button) return;
    event.preventDefault();

    const grid = page.querySelector('[data-search-grid]');
    const pagination = page.querySelector('[data-search-pagination]');
    if (!grid || !pagination || button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    const label = button.querySelector('[data-load-label]') || button.querySelector('span');
    const originalLabel = button.dataset.defaultLabel || label.textContent || 'LOAD MORE PRODUCTS';
    const message = pagination.querySelector('.lkz-search__message');
    if (message) message.textContent = '';
    label.textContent = 'LOADING PRODUCTS...';

    try {
      const response = await fetch(button.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Unable to load more products.');
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = documentFragment.querySelector('[data-search-grid]');
      const nextButton = documentFragment.querySelector('[data-load-more]');
      const newCards = nextGrid ? [...nextGrid.children] : [];

      newCards.forEach((card) => {
        if (card.matches('[data-search-card]:not(.is-sold-out)')) {
          const firstSoldOut = grid.querySelector('[data-search-card].is-sold-out');
          if (firstSoldOut) {
            grid.insertBefore(card, firstSoldOut);
            return;
          }
        }
        grid.appendChild(card);
      });
      const visible = grid.querySelectorAll('[data-search-card]').length;
      const visibleCount = pagination.querySelector('[data-visible-count]');
      if (visibleCount) visibleCount.textContent = visible;
      const total = parseInt(pagination.dataset.total || '0', 10);
      const progress = pagination.querySelector('.lkz-search__progress');
      const progressBar = pagination.querySelector('.lkz-search__progress span');
      const percent = total > 0 ? Math.min(100, (visible / total) * 100) : 0;
      if (progress) progress.setAttribute('aria-valuenow', String(Math.min(visible, total)));
      if (progressBar) progressBar.style.width = `${percent}%`;
      const resultCount = page.querySelector('[data-result-count]');
      if (resultCount && pagination.hasAttribute('data-filtered-search')) resultCount.textContent = visible;
      pagination.dataset.visible = visible;

      if (nextButton && visible < total) {
        button.href = nextButton.href;
        label.textContent = originalLabel;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      } else {
        const status = pagination.querySelector('.lkz-search__status');
        if (status) status.innerHTML = `All <strong>${visible}</strong> matching products loaded`;
        if (progress) progress.setAttribute('aria-valuenow', String(total));
        if (progressBar) progressBar.style.width = '100%';
        pagination.classList.add('is-complete');
        button.remove();
      }
    } catch (error) {
      label.textContent = originalLabel;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.setAttribute('title', error.message);
      if (message) message.textContent = 'Unable to load products. Please try again.';
    }
  });
})();
